// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","Icons":"Footer_Icons__3PTSJ"};